import { memo, useId } from 'react';

interface PropertyTableCheckboxCheckedIconProperties {
  size?: number;
}

/** Figma node 75644:19239 — property table checkbox (checked) */
const PropertyTableCheckboxCheckedIcon = memo(
  ({ size = 15 }: PropertyTableCheckboxCheckedIconProperties) => {
    const clipId = useId();

    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 15 15'
        fill='none'
        aria-hidden
      >
        <g clipPath={`url(#${clipId})`}>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2.22281 0.00244141H12.5959C13.8236 0.00244141 14.8187 0.997629 14.8187 2.22525V12.5983C14.8187 13.826 13.8236 14.8212 12.5959 14.8212H2.22281C0.995188 14.8212 0 13.826 0 12.5983V2.22525C0 0.997629 0.995188 0.00244141 2.22281 0.00244141ZM6.11272 10.8423L11.6401 4.9593C11.8909 4.66857 11.878 4.23441 11.6105 3.95904C11.4713 3.81877 11.2819 3.73987 11.0844 3.73987C10.8869 3.73987 10.6975 3.81877 10.5583 3.95904L5.57184 9.26414L4.26779 7.87859C4.09223 7.66379 3.81137 7.56502 3.54001 7.62274C3.26865 7.68046 3.05225 7.88489 2.97926 8.15259C2.90628 8.42021 2.98893 8.70621 3.19343 8.89367L5.03095 10.8423C5.17188 10.9901 5.36759 11.0733 5.57184 11.072C5.77608 11.0733 5.97179 10.9901 6.11272 10.8423Z'
            fill='#8B5CF6'
          />
        </g>
        <defs>
          <clipPath id={clipId}>
            <rect width='14.8187' height='14.8187' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

PropertyTableCheckboxCheckedIcon.displayName = 'PropertyTableCheckboxCheckedIcon';

export default PropertyTableCheckboxCheckedIcon;
